import { Announcement } from '../announcement'
import { Award, AwardType } from '../award'
import { API, unwrapData } from '../axios-instance'
import { Incentive } from '../incentive'
import { Recognition } from '../recognition'
import { CursorResult } from '../shared/types'

export type PinItemParams = {
  days?: number
}

export type TimelineItemsParams = {
  announcementEmbeds?: string[]
  awardEmbeds?: string[]
  recognitionEmbeds?: string[]
  incentiveEmbeds?: string[]
  awardTypeEmbeds?: string[]
  cursor?: string | null
  pageSize?: number
  itemIdIn?: string[]
  memberIdIn?: string[]
  teamIdIn?: string[]
  itemTypeIn?: string[]
  includePinned?: boolean
  senderId?: string
  recipientId?: string
}

export type PinnedTimelineItemsParams = {
  announcementEmbeds?: string[]
  awardEmbeds?: string[]
  recognitionEmbeds?: string[]
  incentiveEmbeds?: string[]
  awardTypeEmbeds?: string[]
  pageSize?: number
}

export type TimelineItem = Recognition | Announcement | Award | Incentive | AwardType

/**
 * All-time counts of the recognition and awards a member sent and received.
 * Delegated sends and flagged items are left out; private recognition is
 * counted, and the counts ignore what the requesting user is allowed to see, so
 * every viewer of a profile gets the same numbers.
 */
export type MemberAllTimeStats = {
  recognitionsReceived: number
  recognitionsSent: number
  awardsReceived: number
  awardsSent: number
  /**
   * Distinct recipients across the recognition and awards the member sent — the
   * "Colleagues recognized" metric. De-duplicated by the endpoint, so a
   * colleague recognized twice counts once.
   */
  membersAwardedOrRecognized: number
}

// call endpoint with itemId of a pinned item to unpin
export const pinItem = async (itemId: string, params?: PinItemParams) => {
  return await API.put(`timeline/items/${itemId}/pin`, params).then(unwrapData)
}

export const listTimelineItems = async (params: TimelineItemsParams) => {
  return await API.get<CursorResult<TimelineItem>>('timeline/items', { params }).then(unwrapData)
}

export const listPinnedTimelineItems = async (params: PinnedTimelineItemsParams) => {
  return await API.get<CursorResult<TimelineItem>>('timeline/items/pinned', { params }).then(
    unwrapData,
  )
}

export const getMemberAllTimeStats = async (memberId: string) => {
  return await API.get<MemberAllTimeStats>(`timeline/member/${memberId}/allTimeStats`).then(
    unwrapData,
  )
}
